import { create } from 'zustand';
import { createSelectors } from './createSelectors';
import { useEffect } from 'react';

type BaseStore = {
  show: boolean;
};

interface PageLoaderStore extends BaseStore {
  setter: (value: Partial<BaseStore>) => void;
}

const usePageLoaderStoreBase = create<PageLoaderStore>()((set, get) => ({
  show: false,

  setter: value => {
    set(value);
  },
}));

export const usePageLoaderStore = createSelectors(usePageLoaderStoreBase);
export const usePageLoaderBind = (condition: boolean) => {
  const setter = usePageLoaderStore.use.setter();
  useEffect(() => {
    setter({ show: condition });
  }, [condition]);
};
